module.exports = __webpack_public_path__ + "img/desktop_20250806.b71f87e6.jpg";